var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-lg-6 col-md-6 col-sm-6 col-xs-12 text-center"},[_c('div',{class:_vm.data.bgColor},[_c('div',{staticClass:"inner-bag-box"},[_c('p',[_vm._v("Current "+_vm._s(_vm.data.title)+": "+_vm._s(_vm.data.num))]),_c('h3',[_vm._v(_vm._s(_vm.data.name))]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.data.description)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }